module.exports = __webpack_public_path__ + "media/application/images/icons/dont-buy-047458b0d11f94203030ee4c561f31c8.svg";